<template>
  <div class="journey overContainer">

    <div class="topSeparator"></div>

    <div class="overTitle">产品行程</div>
    <div class="overTips"><span class="symbol">* </span>以下行程仅供参考，最终行程可能会根据实际情况进行微调，敬请以签约行程为准</div>

    <div class="bgView bgSpace" v-for="(day, index) in overviews" :key="index">
        <div class="leftView outLeft">
            <div class="circle"></div>
            <div class="line"></div>
        </div>
        <div class="rightView outRight">
            <div class="bgView">
              <div class="leftView">
                  <span class="title">{{day.journeyName}}</span>
              </div>
              <div class="rightView titleRight">
                  <span v-for="(item, i) in day.dayTitles" :key="i">
                      <img :src="item.content" v-if="item.type == 'image'" class="trafficIcon" />
                      <span v-else class="destTitle">{{item.content}}</span>
                  </span>
              </div>
            </div>
            <div v-for="(item, i) in day.dayContents" :key="i" class="bgView actBg">
                <div class="leftView">
                    <img :src="item.iconUrl" class="actIcon" />
                    <span class="actName">{{item.name}}</span>
                </div>
                <div class="rightView actRight">
                    <span class="actContent">{{item.content}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="search" @click="showDetail">查看行程详情</div>

    <div class="bottomSeparator"></div>
  </div>

</template>

<script>
  import { getJourneyFourP } from 'create-api';
  import journeyUtils from '@/util/journeyUtils';

  export default {
      name: 'JourneyOverview',
      props: {
          journeyId: {
              type: Number,
              default: 0
          }
      },
      data () {
        return {
          overviews: []
        }
      },
      watch: {
        journeyId: {
          handler (val) {
            if (val) {
              this.getJourneyDetail(val);
            }
          },
          immediate: true
        }
      },
      methods: {
          showDetail() {
              location.href = 'https://m.tuniu.com/h5/product/journey/' + this.journeyId;
          },
          getJourneyDetail(journeyId) {
            getJourneyFourP({ journeyId }).then(res => {
              if (res && res.success && res.data && res.data.overview && res.data.overview.length) {
                this.overviews = res.data.overview;
                journeyUtils.handleJourneyOverviews(this.overviews)
              } else {
                this.overviews = [];
              }
            })
          }
      }
  }

</script>

<style lang="scss">
  .overContainer {
    background: white;
  }
  .overTitle {
    margin-top: 15px;
    font-family:PingFangSC-Medium;
    font-size:16px;
    color:#051b28;
    line-height:16px;
    text-align:center;
  }
  .overTips {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #A5A5A5;
    margin-top: 18px;
    .symbol {
      color: #FF6436;
    }
  }
  .bgSpace {
    margin-top: 18px;
  }
  .bgView {
    display: flex;
  }
  .leftView {
    float: left;
  }
  .rightView {
    background: white;
    flex: 1;
  }
  .outLeft {
    margin-left: 16px;
  }
  .outRight {
    margin-left: 10px;
    margin-right: 14px;
  }
  .titleRight {
    margin-left: 15px;
    background: white;
  }
  .circle {
    background:#ffffff;
    border:2px solid #2dbb55;
    width:6px;
    height:6px;
    border-radius:100%;
    margin-top: 5px;
  }
  .line {
    opacity:0.2;
    background:#2dbb55;
    width:2px;
    margin-left: 4px;
    margin-top: 3px;
    height: 100%;
  }
  .title {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #222222;
    line-height: 20px;
  }
  .trafficIcon {
    width: 14px;
    height: 14px;
    margin-left: 5px;
    margin-right: 5px;
  }
  .destTitle {
    font-family:PingFangSC-Medium;
    font-size:16px;
    color:#222222;
    line-height:20px;
  }
  .actBg {
    margin-top: 9px;
  }
  .actRight {
    margin-left: 6px;
  }
  .actIcon {
    width: 12px;
    height: 11px;
  }
  .actName {
    margin-left: 3px;
    font-family:PingFangSC-Regular;
    font-size:14px;
    color:#a5a5a5;
    line-height:21px;
    text-align:left;
  }
  .actContent {
    font-family:PingFangSC-Regular;
    font-size:14px;
    color:#666666;
    line-height:21px;
    text-align:left;
  }
  .search {
    background-color: white;
    width:109px;
    height:30px;
    font-size:13px;
    color:#2dbb55;
    border: 1px solid #2dbb55;
    border-radius: 10px;
    line-height: 30px;
    text-align: center;
    margin: 9px auto 0;
  }
  .topSeparator {
    background: #f7f7f7;
    height: 9px;
  }
  .bottomSeparator {
    background: white;
    height: 14px;
  }
</style>



// WEBPACK FOOTER //
// JourneyOverview.vue